import { getWeeklyOptions } from 'pages/addMoneyPool/moneyPool/memberShip/utils/indx'
import React from 'react'
interface WklItemProps {
    setDateValue: React.Dispatch<React.SetStateAction<number>>
    onHide: () => void
}
export default function WklItem({ setDateValue, onHide }: WklItemProps) {
    return (
        <div>
            {getWeeklyOptions.map((item, index) => (
                <div
                    key={index}
                    className=" text-center my-3"
                    onClick={() => {
                        setDateValue(Number(item.value))
                        onHide()
                    }}
                >
                    {item.label}
                </div>
            ))}
        </div>
    )
}
